import * as authActions from "../stores/actions/auth";
import Http from "../utils/Http";
import { me } from "stores/models/Me";
import APPCONFIG from "constants/Config";
import { serializeInput } from "utils/helpers";
import { isFeatureEnabled } from "utils/helpers";
import { broadcastLogout } from './multiTabAuthSync';

export function login(credentials) {
  return dispatch =>
    new Promise((resolve, reject) => {
      const urlParams = new URLSearchParams(window.location.search);
      const isV2 = urlParams.get('request_uri');
      const endpoint = isV2 ? 'v2/login' : 'login';
      const config = isV2 ? {
        headers: { 'Accept': `application/vnd.${APPCONFIG.api_subtype}.v2+json` },
        withCredentials: true
      } : {};
      const loginCredentials = isV2 ? { ...credentials, request_uri: isV2 } : credentials;

      Http.post(endpoint, loginCredentials, config)
        .then(res => {
          if (res.data) {
            dispatch(authActions.authLogin(res.data));

            if (isV2 && res.data.redirect_url) {
              window.location.href = res.data.redirect_url;
            }

            return resolve();
          } else {
            const error = new Error(res.data.meta?.message || 'Login failed');
            dispatch(authActions.serverError(error.message));
            return reject(error);
          }
        })
        .catch(err => {
          return reject(err);
        });
    });
}

export function logout() {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.post("logout")
        .then(res => {
          dispatch(authActions.authLogout());
          try { broadcastLogout(); } catch (e) { /* ignore */ }
          return resolve();
        })
        .catch(err => {
          return reject(err);
        });
    });
}

export function getShopifyShop(code, shop) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("shopify/shop?code=" + code + "&shop=" + shop)
        .then(res => {
          dispatch(authActions.fetchShopDataResolved(res.data.data.shop));
          return resolve(res.data);
        })
        .catch(err => {
          return reject(err);
        });
    });
}

export function forgetPassword(credentials) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.post("password/email", credentials)
        .then(res => {
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function resetPassword(credentials) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.post("password/reset", credentials)
        .then(res => {
          dispatch(authActions.authLogin(res.data));
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function fetchNotifications(pageNumber = null) {
  if (!isFeatureEnabled("EnableUserWebNotifications")) {
    return;
  }
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("notifications?page=" + pageNumber)
        .then(res => {
          if (pageNumber) {
            dispatch(authActions.AddPageNotificationsResolved(res.data));
          } else {
            dispatch(authActions.fetchNotificationsResolved(res.data.data));
            dispatch(authActions.fetchPageNotificationsResolved(res.data));
          }

          return resolve(res.data);
        })
        .catch(err => {
          // dispatch(authActions.serverError('Notification fetch error'))
          return reject(err);
        });
    });
}

export function getMe() {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("me")
        .then(res => {
          dispatch(authActions.getMe(res.data.data));
          return resolve(res.data);
        })
        .catch(err => {
          return reject(err);
        });
    });
}

export function readNotifications() {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.put("notifications")
        .then(res => {
          dispatch(authActions.readNotificationsResolved(res.data.data));
          return resolve(res.data);
        })
        .catch(err => {
          return reject(err);
        });
    });
}

export function updateUser(info) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.put("me", info.input)
        .then(res => {
          dispatch(authActions.updateUserResolved(me(res.data.data)));
          dispatch(authActions.serverSuccess(res.data.meta.message));
          return resolve();
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function fetchDashboardData() {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("dashboard")
        .then(res => {
          dispatch(authActions.fetchDashboardDatasResolved(res.data.data));
          return resolve(res.data);
        })
        .catch(err => {
          // dispatch(authActions.serverError(err.error))
          return reject(err);
        });
    });
}

export function fetchDashboardBlocksData(block, input = []) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get(`dashboard/blocks?block=${block}&${serializeInput(input)}`)
        .then(res => {
          return resolve(res.data);
        })
        .catch(err => {
          return reject(err);
        });
    });
}

export function makeDefaultLocation(id, action) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.put(`locations/${id}`, action)
        .then(res => {
          dispatch(authActions.makeDefaultLocation(res.data.data));
          return resolve();
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}
